import React from 'react';
import ReactDOM from 'react-dom';
import App from './App';
import * as moment from "moment";
import { FocusStyleManager } from "@blueprintjs/core";
import 'dayjs/locale/pt-br';

const numeral = require("numeral");

require("numeral/locales/pt-br");
require("moment/locale/pt-br");

numeral.locale("pt-br");
moment.locale("pt-br");

FocusStyleManager.onlyShowFocusOnTabs();

ReactDOM.render(
    <App />
,document.getElementById('root'));